import { Injectable, signal } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class RestLoggingService {
	readonly currentDashboard = signal<string | null>(null);
}
